import { Modal } from "@components";
import { formatPrice, toIsoDateFr } from "@utilities/functions";
import { Product } from "@utilities/types";
import { FC, useMemo } from "react";

interface Props {
    isOpen: boolean;
    product: Product | null;
    onClose: () => void;
}

export const PricingEvolutionModal:FC<Props> = ({
    isOpen,
    onClose,
    product,
})=> {

    const sellingHistory = useMemo(()=> (
        product?.productSellingPrices || []
    ), [product]);

    const purchaseHistory = useMemo(()=> (
        product?.productPurchasePrices || []
    ), [product]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Évolution des prix"
        >
            <div className="space-y-6">
                {/* Prix de vente */}
                <div>
                    <h3 className="text-lg font-semibold mb-3">Prix de vente</h3>
                    <table className="table w-full text-sm">
                        <thead>
                            <tr className="text-left border-b">
                                <th className="py-2">Date</th>
                                <th className="py-2">Prix</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sellingHistory
                                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                                .map((entry, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="py-2">{toIsoDateFr(entry.date)}</td>
                                        <td className="py-2">{formatPrice(entry.price)}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    {sellingHistory.length === 0 && (
                        <p className="text-gray-500 text-center py-4">Aucun historique de prix de vente</p>
                    )}
                </div>

                {/* Prix d'achat */}
                <div>
                    <h3 className="text-lg font-semibold mb-3">Prix d&#39;achat</h3>
                    <table className="table w-full text-sm">
                        <thead>
                            <tr className="text-left border-b">
                                <th className="py-2">Date</th>
                                <th className="py-2">Prix</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchaseHistory
                                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                                .map((entry, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="py-2">{toIsoDateFr(entry.date)}</td>
                                        <td className="py-2">{formatPrice(entry.price)}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    {purchaseHistory.length === 0 && (
                        <p className="text-gray-500 text-center py-4">Aucun historique de prix d&#39;achat</p>
                    )}
                </div>
            </div>
        </Modal>
    )
}
